import { Link } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { ArrowLeft } from "lucide-react";
import { ContentProvider, useContent } from "@/context/ContentContext";
import { ShowreelProvider } from "@/components/site/Showreel";
import { Analytics } from "@/components/site/Analytics";
import { Grain } from "@/components/site/Grain";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { Reveal } from "@/components/site/Reveal";
import { FormationCard, publishedFormations } from "@/components/site/Formations";

const FormationsBody = () => {
  const { content } = useContent();
  const fm = content.formations || {};
  const items = publishedFormations(fm);

  return (
    <div className="App bg-[#050505] min-h-screen flex flex-col">
      <Grain />
      <Toaster theme="dark" position="bottom-right" />
      <Navbar />
      <main className="flex-1 pt-32 md:pt-40 pb-24" data-testid="formations-page">
        <div className="max-w-[1500px] mx-auto px-6 md:px-12">
          <Reveal className="mb-14 max-w-2xl">
            <Link to="/" className="inline-flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase text-secondary2 hover:text-electric transition-colors mb-8"><ArrowLeft size={14} /> Accueil</Link>
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-electric" />
              <span className="text-xs tracking-[0.35em] uppercase text-electric">{fm.eyebrow || "Formations"}</span>
            </div>
            <h1 className="font-serif text-5xl md:text-7xl text-white tracking-tight leading-[0.95] mb-6">{fm.heading || "Apprendre le cinéma."}</h1>
            {fm.intro && <p className="text-base md:text-lg text-secondary2 font-light leading-relaxed">{fm.intro}</p>}
          </Reveal>

          {items.length === 0 ? (
            <p className="text-secondary2">Aucune formation programmée pour le moment.</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {items.map((it, i) => <FormationCard key={it.id || i} it={it} fm={fm} i={i} contactHref="/#contact" />)}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default function FormationsPage() {
  return (
    <ContentProvider>
      <ReactLenis root options={{ lerp: 0.08, duration: 1.2, smoothWheel: true }}>
        <ShowreelProvider>
          <Analytics />
          <FormationsBody />
        </ShowreelProvider>
      </ReactLenis>
    </ContentProvider>
  );
}
